<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";
import TableAnalytics from "./table.vue";
export default {
  name: "AnalyticsList",
  props: ["type", "journeyLevel"],
  components: {
    Multiselect,
    TableAnalytics,
  },
  data() {
    return {
      benefits: ['benefit_1'],
      primary_benefit: "false",
      primary_level: "false",
      tabIndex: 0,
      jlevel: this.journeyLevel ? this.journeyLevel : "",
      equipments: [],
      status: [],
      primaryOptions: [
        {
          text: "Yes",
          value: "true",
        },
        {
          text: "No",
          value: "false",
        },
      ],
      journey: 1,
      statuses: [
        {
          text: "Draft",
          value: "draft",
        },
        {
          text: "Approved",
          value: "approved",
        },
        {
          text: "Published",
          value: "published",
        },
      ],
      benefitsOptions: [
        {
          text: "1",
          value: "benefit_1",
        },
        {
          text: "2",
          value: "benefit_2",
        },
        {
          text: "3",
          value: "benefit_3",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentPaginationPage: "commons/currentPaginationPage",
      currentDataList: "commons/currentDataList",
      journeyReport: "commons/journeyReport",
      journeyList: "commons/journeyList",
    }),
    equipmentsCategories() {
      return this.$store.getters[`commons/equipmentCategoryList`];
    },
    remappedJourney() {
      return this.journeyList.map((data) => {
        return {
          text: data.label,
          value: data.id,
        };
      });
    },
    remmapedEquipmentsCategories() {
      return this.equipmentsCategories.map((category) => {
        return {
          text: category.label,
          value: category.id,
        };
      });
    },
  },
  watch: {
    tabIndex(val) {
      console.log(val);
    },
  },
  mounted() {
    this.$store.dispatch(`commons/getEquipmentsCategories`);
  },
  methods: {
    optionValue(id, type) {
      const data =
        this.fieldOptionsChunked[type] && id
          ? this.fieldOptionsChunked[type].find((option) => option.id == id)
          : null;

      if (data) return data.label;
    },
    getLevel(id) {
      var journey = this.journeyList.find((journey) => journey.id == id);
      if (journey && journey.levels) {
        return journey.levels.map((data) => {
          return {
            text: data.value,
            value: data.id,
          };
        });
      }
    },

    journeyListLevel(level) {
      if (this.journeyReport.stats) {
        return this.journeyReport.stats[level];
      }
    },
    getJourneyReport() {
      if (!this.jlevel) {
        this.jlevel = this.journeyLevel;
      }
      this.$store.commit("commons/setPreloader", true);
      let filterArgs = {
        equipments: this.equipments,
        status: this.status,
        journey: this.journey,
        benefits: this.benefits,
        level: this.jlevel,
        primary_level: JSON.parse(this.primary_level),
        //primary_benefit: JSON.parse(this.primary_benefit),
      };
      this.$store.dispatch("commons/getJourneyReport", filterArgs).then(
        (res) => {
          this.$store.commit("commons/setPreloader", false);
        },
        (error) => {
          console.error(error);
        }
      );
    },
    equipmentsFunc(newVal) {
      if (newVal != null) {
        this.equipments = newVal;
      }
      this.getJourneyReport();
    },

    statusFunc(newVal) {
      if (newVal != null) {
        this.status = newVal;
      }
      this.getJourneyReport();
    },
    journeyFunc(newVal) {
      this.journey = newVal;
      var option = this.journeyList.find((option) => option.id == newVal);
      this.getLevel(newVal);
      this.jlevel = option.levels[0].id;
      this.getJourneyReport();
    },
    journeyLevelFunc(newVal) {
      if (newVal != null) {
        this.jlevel = newVal;
      }
      this.getJourneyReport();
    },
    primaryLevelFunc(newVal) {
      if (newVal != null) {
        this.primary_level = newVal;
      }
      this.getJourneyReport();
    },
    // primaryBenefitFunc(newVal) {
    //   if (newVal != null) {
    //     this.primary_benefit = newVal;
    //   }
    //   this.getJourneyReport();
    // },
    
    benefitsFunc(newVal) {
      console.log(newVal)
      if (newVal != null) {
        this.benefits = newVal;
      }
      this.getJourneyReport();
    },
  },
};
</script>
<style lang="scss">
.border-style {
  .card-body {
    .tabs {
      .card-header {
        .card-header-tabs {
          background: #fff;
          border-bottom: 1px solid #dfdfdf;
          li {
            background: #fff;
            padding: 0;

            a {
              background: #fff;
              border-radius: 0px;
              border-bottom: 1px solid #dfdfdf !important;

              &.active {
                border: 1px solid #dfdfdf !important;
                border-bottom: 0px solid #dfdfdf !important;
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
              }
            }
          }
        }
      }
      .tab-content {
        box-shadow: 0px 0 0 #00000029;
        border: 1px solid #dfdfdf;
        border-top: 0px solid #dfdfdf;
        padding: 30px 50px;
        min-height: auto !important;

        .b-table-sticky-header {
          max-height: 45vh !important;
        }

        table {
          .sr-only {
            display: none;
          }
          thead {
            tr {
              border-bottom: 1px solid #dfdfdf;
              th {
                background-color: #fff !important;
                font-size: 14px;
                border-top: 0px solid #dee2e6;
                padding: 10px;
              }
            }
          }
          tbody {
            tr {
              border-bottom: 1px solid #dfdfdf;
              &:last-child {
                border: 0;
              }
              td {
                font-size: 14px;
                padding: 10px;
              }
            }
          }
        }
      }
    }
  }
}
.progress-wrapper {
  background-color: #e9ecef;
  width: 100px;
  height: 5px;
  display: inline-block;
  margin-left: 10px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  .progress-status {
    border-radius: 10px;
    position: absolute;
    height: 5px;
    left: 0;
    top: 0;
    &.green {
      background: #469a2e;
    }
    &.yellow {
      background: #fbbd08;
    }
    &.red {
      background: #db2828;
    }
  }
}
</style>
<template>
  <div class="p-4">
    <h2 class="py-2">Coverage</h2>
    <div class="row">
      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">JOURNEY</label>
          <multiselect
            :options="remappedJourney"
            label="text"
            track-by="text"
            v-model="journey"
            @change="journeyFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">JOURNEY LEVEL</label>
          <multiselect
            :options="getLevel(journey)"
            label="text"
            track-by="text"
            v-model="journeyLevel"
            @change="journeyLevelFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">PRIMARY LEVEL</label>
          <multiselect
            :options="primaryOptions"
            label="text"
            track-by="text"
            v-model="primary_level"
            @change="primaryLevelFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>
  
      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">BENEFITS</label>
          <multiselect
            :options="benefitsOptions"
            label="text"
            track-by="text"
            :create-tag="true"
            mode="tags"
            v-model="benefits"
            @change="benefitsFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">EQUIPMENT</label>
          <multiselect
            :options="remmapedEquipmentsCategories"
            label="text"
            track-by="text"
            :create-tag="true"
            mode="tags"
            v-model="equipments"
            @change="equipmentsFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="col-md-2">
        <div class="form-group">
          <label class="d-block">STATUS</label>
          <multiselect
            :options="statuses"
            label="text"
            track-by="text"
            :create-tag="true"
            mode="tags"
            v-model="status"
            @change="statusFunc"
          >
            <template v-slot:singlelabel="{ value }">
              <div class="multiselect-single-label" v-if="value">
                {{ value.text }}
              </div>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <b-card class="border-style">
      <b-tabs card v-model="tabIndex">
        <b-tab title="Level 1" active>
          <table-analytics :analytics="journeyListLevel(1)"></table-analytics>
        </b-tab>
        <b-tab title="Level 2">
          <table-analytics :analytics="journeyListLevel(2)"></table-analytics>
        </b-tab>
        <b-tab title="Level 3">
          <table-analytics :analytics="journeyListLevel(3)"></table-analytics>
        </b-tab>
        <b-tab title="Level 4">
          <table-analytics :analytics="journeyListLevel(4)"></table-analytics>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>